export * from "./ClinicPageArticle";
export * from "./ClinicPageArticle.types";
